import React from 'react';
import {FormikDayPicker} from './FormikDayPicker';
import {RawDayPicker} from './RawDayPicker';

export function DayPicker({raw, ...props}) {
    if (raw) {
        return <RawDayPicker {...props} />;
    } else {
        return <FormikDayPicker {...props} />;
    }
}
